// Per attempt: with one retry a hanging search falls back to the GraphQL table
// after about 8 seconds. typesense-js treats 0 retries as its default of 3.
export const SEARCH_CONNECTION_TIMEOUT_SECONDS = 4

export const SEARCH_NUM_RETRIES = 1
